/**
 * Estimativa de duração da sessão, num lugar só.
 *
 * Os frames mostram "≈ 21 s por cartão" na conclusão
 * (openspec/changes/flashcards-revisao-redesign/design.md, Open Questions).
 * Até a API entregar a média real do aluno, toda estimativa multiplica a
 * contagem anunciada por `SEGUNDOS_POR_CARTAO`. Não duplique o 21 noutro arquivo.
 */

/** Segundos fixos por cartão, enquanto a média do aluno não existe. */
export const SEGUNDOS_POR_CARTAO = 21;

export interface EstimativaDuracao {
  /** `cartoes * SEGUNDOS_POR_CARTAO`. Zero cartões produz zero segundos. */
  segundos: number;
  /**
   * Abaixo de um minuto, em segundos ("≈ 42 s").
   * De um minuto para cima, minutos arredondados ("≈ 37 min").
   * Zero cartões produz "≈ 0 min".
   */
  rotulo: string;
}

function cartoesInteiros(cartoes: number): number {
  if (!Number.isFinite(cartoes) || cartoes <= 0) return 0;
  return Math.floor(cartoes);
}

/** Duração anunciada para a contagem que a barra já mostra. */
export function estimativaDuracao(cartoes: number): EstimativaDuracao {
  const n = cartoesInteiros(cartoes);
  const segundos = n * SEGUNDOS_POR_CARTAO;
  if (n === 0) return { segundos: 0, rotulo: "≈ 0 min" };
  if (segundos < 60) return { segundos, rotulo: `≈ ${segundos} s` };
  const minutos = Math.max(1, Math.round(segundos / 60));
  return { segundos, rotulo: `≈ ${minutos} min` };
}
